import Vue from "vue";
import axios from "axios";

const GraphqlData = new Vue({
  data() {
    return {};
  },
  created() {},
  methods: {
    authenticateAndFetchData(manufacturer, component, model, trim, graphqlEndpoint) {
      return Promise.resolve(null)
        .then((authToken) => {
          if (component == "bp-models") {
            return this.getModelsData(authToken, manufacturer, component, graphqlEndpoint);
          }
          if (component == "bp-categories") {
            return this.getCategories(authToken, manufacturer, component, graphqlEndpoint);
          }
          if (component == "bp-trims") {
            return this.getTrimsData(authToken, manufacturer, model, component, graphqlEndpoint);
          } 
          if (component == "bp-detail") {
            return this.getTrimData(authToken, manufacturer, model, component, trim, graphqlEndpoint);
          }
          if (component == "special-offers") {
            return this.specialOffers(authToken, graphqlEndpoint);
          }
          if (component == "offer-model-images") {
            return this.getOfferModelImages(authToken, manufacturer, graphqlEndpoint);
          }
          if (component == "offer-model-categories") {
            return this.getOfferModelCategories(authToken, manufacturer, graphqlEndpoint);
          }
          if (component == "lineup") {
            return this.getLineupData(authToken,manufacturer, graphqlEndpoint);
          } 
          if (component == "model") {
            return this.getModelData(authToken, manufacturer, graphqlEndpoint);
          } else {
            return null;
          }
        })
        .catch((error) => {
          console.error("Error:", error.message);
          throw error;
        });
    },
    fetchData(authToken, query, component, graphqlEndpoint) {
      return axios
        .post(`${graphqlEndpoint}`, { query: query })
        .then((response) => {
          if (response.data.errors) {
            throw new Error(response.data.errors[0].message);
          } else {
            if (component == "bp-models" || component == "bp-categories" || component == "lineup")
              return response.data.data.modelLists.nodes;
            else if (component == "bp-trims"){
              return response.data.data;
            }
            else if (component == "bp-detail"){
              return response.data.data;
            }else if(component == "special-offers"){
              return response.data.data.offers.nodes;
            }else if(component == "offer-model-images" || component == "offer-model-categories"){
              return response.data.data;
            }else if(component == "model"){
              return response.data.data.modelList;
            }
            else return null;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCategories(authToken, manufacturer, component, graphqlEndpoint) {
      const query = `        {
        modelLists(first: 100, where: { search: "${manufacturer}" }) {
          nodes {
            modelData {
              category
            }
            }
          }
        }`;

      return this.fetchData(authToken, query, component, graphqlEndpoint)
        .then((response) => {
          // Convert response data to object
          let categories = {};
          response.forEach((item) => {
            if (!categories[item.modelData.category]) {
              categories[item.modelData.category] = 1;
            }
          });
          // remove duplicates from object
          categories = Object.keys(categories);

          const allCategories = categories.reduce((result, category) => {
            return result.concat(category.split(",").map((c) => c.trim()));
          }, []);

          // Paso 2: Eliminar duplicados
          const uniqueCategories = [...new Set(allCategories)];

          // Add "All" category first
          uniqueCategories.unshift("All");

          return uniqueCategories;
        })
        .catch((error) => {
          console.error("Error fetching categories:", error);
          throw error;
        });
    },
    getModelsData(authToken, manufacturer, component, graphqlEndpoint) {
      const query = `        {
        modelLists(first: 100, where: { search: "${manufacturer}", orderby: {field: DATE, order: ASC} }) {
          nodes {
            databaseId
            modelData {
              category
              year
              make
              model
              startingPrice
              fuel
              features
              financeOffers {
                term
                rate
                regionKey
              }
              leaseOffers {
                term
                rate
                mileage
                residual
                regionKey
              }
              jellybean {
                sourceUrl(size: THUMBNAIL)
                medium: sourceUrl(size: MEDIUM)
                large: sourceUrl(size: LARGE)
              }
            }
            }
          }
        }`;

      return this.fetchData(authToken, query, component, graphqlEndpoint);
    },
    getTrimsData(authToken, manufacturer, model, component, graphqlEndpoint) {
      model = model.replace(/ /g, "-").trim();

      const query = `
      {
        modelList(id: "${model}", idType: SLUG) {
          title
          modelData {
            year
            make
            model
            trims {
              ... on ModelTrim {
                trimData {
                  name
                  fuel
                  features
                  description
                  descriptionFr
                  startingPrice
                  category
                  jellybean {
                    sourceUrl(size: THUMBNAIL)
                  }
                }
              }
            }
          }
        }
        options(first: 100, where: {search: "${model.replace(/-/g, " ").trim()}"}) {
          nodes {
            options {
              category
              preselector
              unique
              items {
                included
                code
                require
                include
                remove
                dataCondition
                description
                name
                price
                icon
                trims {
                  ... on ModelTrim {
                    trimData {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }`;

      return this.fetchData(authToken, query, component, graphqlEndpoint);
    },
    getTrimData(authToken, manufacturer, model, component, trim, graphqlEndpoint) {
      if(model && trim){
        model = model.replace(/ /g, "-").trim();
        trim = trim.replace(/ /g, "-").trim();

        const query = `
        {
          modelTrim(id: "${model}-${trim}", idType: SLUG) {
            trimData {
              startingPrice
              colorizer {
                isJellybean
                colorName
                colorNameFr
                hexCode
                price
                images {
                  url
                  imageType
                  style
                  image {
                    sourceUrl(size: LARGE)
                  }
                }
              }
              financeOffers {
                isBestOffer
                term
                rate
                regionKey
              }
              leaseOffers {
                isBestOffer
                rate
                mileage
                regionKey
                term
                residual
              }
              interior {
                price
                name
                hexCode
              }
            }
          }
          options(first: 100, where: {search: "${model.replace(/-/g, " ").trim()}"}) {
            nodes {
              options {
                category
                preselector
                unique
                items {
                  included
                  code
                  require
                  include
                  remove
                  dataCondition
                  description
                  name
                  price
                  icon
                  image {
                    sourceUrl(size: THUMBNAIL)
                  }
                  trims {
                    ... on ModelTrim {
                      trimData {
                        name
                      }
                    }
                  }
                }
              }
            }
          }
          accessory(first: 100, where: {search: "${manufacturer}"}) {
            nodes {
              accessories {
                code
                description
                make
                price
                name
                models {
                  ... on ModelList {
                    modelData {
                      year
                      make
                      model
                    }
                  }
                }
              }
            }
          }
          protections(first: 100, where: {search: "${manufacturer}"}) {
            nodes {
              protections {
                code
                description
                descriptionFr
                name
                nameFr
                type
                paymentMethod
                plan {
                  brochure
                  brochureFr
                  fieldGroupName
                  planName
                  planNameFr
                  programData {
                    models {
                      ... on ModelList {
                        modelData {
                          make
                          model
                        }
                      }
                    }
                    data {
                      kmAllowance
                      duration
                      cost
                    }
                  }
                }
              }
            }
          }
        }`;

        return this.fetchData(authToken, query, component, graphqlEndpoint);
      }else
        return null;

    },
    specialOffers(authToken, graphqlEndpoint) {
      const query = `
      {
        offers(first: 1000) {
          nodes {
            databaseId
            title
            offers {
              notAVehicle
              year
              make
              model
              trim
              contentAlignment
              legalEn
              legalFr
              downPayment
              downPaymentLabel
              downPaymentLabelFr
              leaseLabel
              leaseLabelFr
              leaseDisclaimer
              leaseDisclaimerFr
              leaseApr
              financeApr
              financeDisclaimer
              financeDisclaimerFr
              financeLabel
              financeLabelFr
              financeLegalEn
              financeLegalFr
              paymentLabel
              paymentLabelFr
              paymentTaxLabel
              paymentTaxLabelFr
              payment
              paymentDisclaimer
              paymentDisclaimerFr
              normalOfferLine1
              normalOfferLine2
              normalOfferLine1Fr
              normalOfferLine2Fr
              province
              startDate
              endDate
              mainImage {
                sourceUrl
              }
              mainImageMobile {
                sourceUrl
              }
              desktopImage {
                sourceUrl
              }
              mobileImage {
                sourceUrl
              }
            }
          }
        }
      }`;

      return this.fetchData(authToken, query, 'special-offers', graphqlEndpoint);
    },
    // Model categories (SUVs, Trucks, Electric...) for the Multi-Brand offers type filter.
    // Same aliased shape as getOfferModelImages, without the images, so it stays light.
    getOfferModelCategories(authToken, makes, graphqlEndpoint) {
      const list = (Array.isArray(makes) ? makes : [makes]).filter(Boolean);

      if (!list.length)
        return Promise.resolve(null);

      const query = list.map((make, index) => `
        m${index}: modelLists(first: 100, where: { search: "${String(make).replace(/"/g, '')}" }) {
          nodes {
            modelData {
              make
              model
              category
            }
          }
        }`).join('');

      return this.fetchData(authToken, `{${query}}`, 'offer-model-categories', graphqlEndpoint);
    },
    // Model jellybeans, used as a fallback for offers with no image of their own.
    // One aliased query per make so a single request covers every brand on the page.
    getOfferModelImages(authToken, makes, graphqlEndpoint) {
      const list = (Array.isArray(makes) ? makes : [makes]).filter(Boolean);

      if (!list.length)
        return Promise.resolve(null);

      const query = list.map((make, index) => `
        m${index}: modelLists(first: 100, where: { search: "${String(make).replace(/"/g, '')}" }) {
          nodes {
            modelData {
              year
              make
              model
              jellybean {
                sourceUrl(size: LARGE)
              }
            }
          }
        }`).join('');

      return this.fetchData(authToken, `{${query}}`, 'offer-model-images', graphqlEndpoint);
    },
    getLineupData(authToken, manufacturer, graphqlEndpoint){
      const query = `
        {
        modelLists(first: 100, where: { search: "${manufacturer}" }) {
          nodes {
            modelData {
              year
              make
              model
              category
              model
              startingPrice
              colorizer {
                colorName
                colorNameFr
                images {
                  url
                  imageType
                  image {
                    sourceUrl(size: THUMBNAIL)
                    srcSet(size: LARGE)
                  }
                }
              }
              jellybean {
                sourceUrl(size: THUMBNAIL)
                srcSet(size: LARGE)
              }
            }
            }
          }
        }`;

      return this.fetchData(authToken, query, 'lineup', graphqlEndpoint);
    },
    getModelData(authToken, url, graphqlEndpoint){
      const query = `
        {
          modelList(id: "${url}", idType: SLUG) {
            title
            featuredImage {
              node {
                sourceUrl
              }
            }
            modelData {
              year
              make
              model
              category
              startingPrice
              features
              description
              descriptionFr
              buildPrice
              content {
                heading
                text
                image {
                  sourceUrl
                }
              }
              contentFr {
                heading
                text
                image {
                  sourceUrl
                }
              }
              financeOffers {
                term
                rate
                regionKey
              }
              leaseOffers {
                term
                rate
                mileage
                residual
                regionKey
              }
              trims {
                ... on ModelTrim {
                  trimData {
                    name
                    jellybean {
                      sourceUrl(size: LARGE)
                    }
                    colorizer {
                      colorName
                      images {
                        url
                        imageType
                        image {
                          sourceUrl(size: MEDIUM)
                        }
                      }
                    }
                  }
                }
              } 
              galleryExt {
                sourceUrl(size: MEDIUM)
                sourceUrlLarge: sourceUrl(size: LARGE)
              }
              galleryInt {
                sourceUrl(size: MEDIUM)
                sourceUrlLarge: sourceUrl(size: LARGE)
              }
              colorizer {
                isJellybean
                colorName
                hexCode
                colorNameFr
                images {
                  url
                  imageType
                  image {
                    sourceUrl(size: MEDIUM)
                  }
                }
              }
            }
          }
        }`;

        return this.fetchData(authToken, query, 'model', graphqlEndpoint);
    }
  },
});

export default GraphqlData;